import { Reducer } from "redux";
import { Action, ActionType } from "../../../actions";
import { TableData } from "../../../state/BookingCreateManager/SSR/TableData";

const updateTableData: Reducer<TableData> = (state: TableData = new TableData(), action: Action<ActionType, TableData>) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_SSR_TABLE_DATA_FETCHED:
      return { ...state, records: action.data };
    default:
      return state;
  }
};

export default updateTableData;
